import { getInstance } from "./index";
/*
    Sjekke om bruker er logget inn..
    Hvis ikke så blir bruker sendt ditt der han/hun hører til.
*/
export const baseGuard = (to, from, next) => {
    const authService = getInstance();

    async function fn() {
        // Bruker ikke logget inn?
        if (!authService.isAuthenticated) {
            return next();
        }

        // Bruker logget inn men har ikke verifisert eposten sin?
        if (authService.isAuthenticated && !authService.user.email_verified) {
            console.log(from.path + " to " + to.path);
            return next("/verifiser-epost");
        }
        // Bruker er logget inn og verifisert og har lyst å gå til Home?
        if (to.name === 'Home') {
            return next({ name: 'Profile' });
        }
        // Bruker er logget inn og verifisert og har lyst å gå til /profile/registrer?
        // Vi må også huske from path, hvor kommer bruker fra?
        if (to.name === 'Registration' && from.path !== "/profil") {
            return next({ name: 'Profile' });
        }
        // Bruker er logget inn og verifisert og har lyst å gå til /verifiser-epost?
        if (to.name === 'VerifiserEpost' && from.path !== "/profil") {
            return next({ name: 'Profile' });
        }
        return next();
    }

    // If loading has already finished, check our auth state using `fn()`
    if (!authService.loading) {
        return fn();
    }

    // Watch for the loading property to change before we check isAuthenticated
    authService.$watch("loading", loading => {
        if (loading === false) {
            return fn();
        }
    });
};